import React, { useCallback, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import AtlasBriefPanel from './AtlasBriefPanel';
import { fetchSharedBrief, fetchSharedBriefImage } from './atlasApi';
import './AtlasChat.css';

export default function AtlasBriefSharedPage() {
  const { shareId } = useParams();
  const navigate = useNavigate();
  const [brief, setBrief] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    async function run() {
      if (!shareId) {
        setError('Missing share id');
        setLoading(false);
        return;
      }
      setLoading(true);
      setError('');
      try {
        const json = await fetchSharedBrief(shareId);
        if (!cancelled) setBrief(json?.brief || null);
      } catch (err) {
        if (!cancelled) setError(err?.message || String(err));
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    run();
    return () => {
      cancelled = true;
    };
  }, [shareId]);

  // Create fetchImage callback bound to current shareId
  const fetchImage = useCallback(
    (imageId) => fetchSharedBriefImage(shareId, imageId),
    [shareId]
  );

  return (
    <div className="atlas-page atlas-page-brief-fullscreen atlas-shared-page">
      {error ? <div className="atlas-error">{error}</div> : null}

      <div className="atlas-split" style={{ flex: '1 1 auto', minHeight: 0 }}>
        <div className="atlas-brief" style={{ width: '100%', maxWidth: 'none' }}>
          <AtlasBriefPanel
            brief={brief}
            isOpen={true}
            isFullscreen={true}
            mode="public"
            isPublishing={false}
            publishError={''}
            shareUrl={''}
            shareId={shareId}
            onClose={() => navigate('/atlas')}
            onToggleFullscreen={() => {}}
            onPublish={() => {}}
            fetchViz={null}
            fetchImage={fetchImage}
          />
        </div>
      </div>

      {loading ? (
        <div className="atlas-activity atlas-activity-info">
          <span className="atlas-spinner" aria-hidden="true" />
          <span className="atlas-activity-text">Loading brief…</span>
        </div>
      ) : null}
    </div>
  );
}
